var _path, _rect, _rect2, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubheaderAuthorizedAgent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28.9999H26M42 41.9999L40 42.9999",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26.9999,
    width: 6,
    height: 14,
    rx: 1,
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 28.9999,
    width: 6,
    height: 14,
    rx: 1,
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 39.9999L25 48.9999C25.8333 49.4999 27.9 50.2999 29.5 49.4999M25 44.9999L30 49.9999C31.1667 50.3332 33.5 50.4999 33.5 48.4999M28 42.9999L34 48.9999C34.3333 49.1665 35.3 49.3999 36.5 48.9999C37.7 48.5999 37.6667 47.1665 37.5 46.4999M32 40.9999L38 46.9999C38.5 46.9999 39.6 46.7999 40 45.9999C40.5 44.9999 40.5 43.4999 40 42.9999C39.6 42.5999 32.5 36.8332 29 33.9999L27 34.9999C25.5 36.1665 22.2 38.1999 21 36.9999C19.5 35.4999 21.5 32.4999 24 30.4999C26.5 28.4999 28.211 27.8421 31.5 28.4999C34 28.9999 37 29.4999 42 30.9999",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2845 10.8749L25.5491 7.38155L26.6428 10.3196L26.3122 10.4421V10.4497L22.1527 12.0152L21.2199 12.3663L21.5679 13.3002L24.607 21.4577L24.9573 22.398L25.8965 22.0444L28.7282 20.9782L29.8068 23.879L26.9674 24.9481L26.0349 25.2992L26.3827 26.2329L26.8945 27.6073L22.637 27.9435L16.2845 10.8749Z",
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.336 9.82157L31.336 9.82156L31.3319 9.82012C31.0982 9.73822 30.861 9.68283 30.6275 9.64576L29.3335 6.16982C30.8667 5.88608 32.2439 5.959 33.4747 6.38019L33.6897 6.46168C35.4824 7.14118 36.9535 8.758 38.0091 11.5937L38.0091 11.5937C39.1805 14.74 39.1375 17.0091 38.2389 18.6009C37.3897 20.1018 35.8552 21.3973 33.5038 22.4239L32.3745 19.391C33.164 18.8968 33.8027 18.2644 34.2158 17.4634L34.2158 17.4634L34.2182 17.4587C34.8714 16.1756 34.7687 14.6687 34.1809 13.0875L34.1804 13.0861C33.5921 11.5106 32.6886 10.3022 31.336 9.82157Z",
    stroke: "#4F7FA7",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubheaderAuthorizedAgent);
export default __webpack_public_path__ + "static/media/subheader-authorized-agent.7c71b90d632d808017cf237ca20bcdca.svg";
export { ForwardRef as ReactComponent };